module.exports = __webpack_public_path__ + "media/src/images/scene_mothers_day-7b079ec48e42f22270c3e1d7d724fc75.svg";